import type { FlattenedSectionProps } from "../../../../components/Questionnaire/Section";
import type { QuestionnaireState } from "../../types";

export const handleEditQuestionAction = (
  state: QuestionnaireState,
  payload: {
    questionName: string;
    assumptionGroupIndex?: number;
  },
): QuestionnaireState => {
  const { questionName, assumptionGroupIndex } = payload;
  const { sections: sectionsFromState } = state;
  const sections = sectionsFromState as unknown as FlattenedSectionProps[];

  // Find the section and question that needs to be edited
  const sectionIndex = sections.findIndex(({ questions }) =>
    questions.some(q => q.name === questionName),
  );

  if (sectionIndex === -1) {
    // If question not found, return unchanged state
    return state;
  }

  const section = sections[sectionIndex];
  const question = section.questions.find(q => q.name === questionName);

  if (!question) {
    return state;
  }

  // Create a new section with just the question to edit
  const editSection = {
    ...section,
    displayAs: "edit",
    questions: [question],
    isVisited: true,
  };

  // Add the edit section to the sections array
  const updatedSections = [...sections, editSection];

  return {
    ...state,
    sections: updatedSections,
    // Set current section to the new edit section
    currentSectionIndex: updatedSections.length - 1,
    // Reset changed list
    selectedQuestion: questionName,
    changedQuestions: [],
    changedAssumptionGroupIndex:
      assumptionGroupIndex ?? state.changedAssumptionGroupIndex,
  };
};
